import { render, staticRenderFns } from "./Landing.vue?vue&type=template&id=6c083611&scoped=true"
var script = {}
import style0 from "./Landing.vue?vue&type=style&index=0&id=6c083611&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c083611",
  null
  
)

export default component.exports